<template>
  <div>
    <v-dialog
      :value="show"
      persistent
      :fullscreen="$vuetify.breakpoint.xs"
      lazy
      :width="$store.state.common.extraLargeDialogWidth"
      scrollable
      @input="(val) => $emit('update:show', val)"
    >
      <v-card class="v-dialog-card-msr-style">
        <v-card-title
          class="d-block"
          style="
            flex-grow: 0;
            box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.33);
            z-index: 1;
          "
          :style="{
            'padding-bottom': showPaginationControls ? '4px' : '16px',
          }"
        >
          <div class="headline mb-2">
            {{ $t('televisionTypeAssign') }}
          </div>
          <v-layout align-center>
            <v-layout
              align-baseline
              wrap
            >
              <v-flex
                xs12
                sm7
              >
                <div>
                  <v-layout
                    align-center
                    wrap
                  >
                    <div
                      v-if="tvdecoder"
                      class="
                        clickable
                        pseudo-anchor--inverted
                        grey--text
                        text--darken-3
                        outlined
                        py-1
                        px-2
                        mb-2
                      "
                      :class="{
                        'body-1': expandChosenTelevisionType,
                        caption: !expandChosenTelevisionType,
                      }"
                      :title="$t('goToDecoderDetailPage')"
                      @click="
                        $router.push({
                          name: 'decoder',
                          params: {
                            ctype: tvdecoder.ctype,
                            decoderId: tvdecoder.id,
                          },
                        })
                      "
                    >
                      {{ tvdecoder.description }}
                    </div>
                    <div
                      class="ml-2 mr-2 mb-2"
                      :class="{
                        'body-1': expandChosenTelevisionType,
                        caption: !expandChosenTelevisionType,
                      }"
                    >
                      {{ $t('televisionTypeAssignIsTypeOf') }}
                    </div>
                    <div
                      v-if="!chosenTelevisionType"
                      class="
                        subheading
                        grey--text
                        text--darken-3
                        outlined
                        py-1
                        px-2
                        mb-2
                      "
                    >
                      &nbsp;?&nbsp;
                    </div>
                    <v-layout
                      v-else
                      class="
                        subheading
                        grey--text
                        text--darken-3
                        outlined
                        pa-2
                        mb-2
                      "
                      :align-center="$vuetify.breakpoint.smAndUp"
                      :align-start="$vuetify.breakpoint.xs"
                      style="position: relative"
                    >
                      <!-- Collapsed preview of chosen TelevisionType -->
                      <div
                        v-if="!expandChosenTelevisionType"
                        class="caption pseudo-anchor--inverted"
                        @click="scrollToChosenTelevisionTypeInList()"
                      >
                        <span v-if="chosenTelevisionType.product_family">
                          <strong>{{
                            chosenTelevisionType.product_family
                          }}</strong>,
                        </span>
                        {{ chosenTelevisionType.label }}
                      </div>
                      <!-- Expanded preview of chosen TelevisionType -->
                      <div
                        v-else
                        :key="(chosenTelevisionType || {id: '?'}).id"
                      >
                        <div
                          class="pseudo-anchor--inverted"
                          @click="scrollToChosenTelevisionTypeInList()"
                        >
                          <span>
                            <strong>{{
                              chosenTelevisionType.product_family
                            }}</strong>,
                            {{ chosenTelevisionType.label }}
                          </span>
                          <div
                            class="mt-1 grey--text text--darken-2"
                            style="font-size: 10px"
                          >
                            {{ chosenTelevisionType.article_number }}
                          </div>
                        </div>
                        <div
                          class="grey--text text--darken-2 mt-1"
                          style="font-size: 10px"
                        >
                          <v-layout
                            justify-end
                            align-center
                            class="mt-1"
                          >
                            <div class="headline grey--text text--darken-3">
                              {{ chosenTelevisionType.screen_diagonal }}"
                            </div>
                            <img
                              v-if="
                                chosenTelevisionType.brand_logo_thumbnail_url
                              "
                              :src="
                                chosenTelevisionType.brand_logo_thumbnail_url
                              "
                              width="64"
                              class="ml-4"
                              style="
                                height: auto;
                                max-height: 64px;
                                object-fit: contain;
                              "
                            >
                            <img
                              v-if="chosenTelevisionType.eek"
                              :src="eekToImageUrl[chosenTelevisionType.eek]"
                              :title="chosenTelevisionType.eek"
                              height="20"
                              class="ml-4"
                            >
                            <img
                              v-if="
                                chosenTelevisionType.product_thumbnail_image_url
                              "
                              :src="
                                chosenTelevisionType.product_thumbnail_image_url
                              "
                              width="64"
                              class="ml-4"
                              style="
                                height: auto;
                                max-height: 64px;
                                object-fit: contain;
                              "
                            >
                          </v-layout>
                        </div>
                      </div>
                      <!-- Expand/collapse toggle button -->
                      <v-btn
                        class="ml-auto mr-0 mt-0 mb-0"
                        style="position: absolute; top: 0px; right: 0px"
                        :style="{
                          position: $vuetify.breakpoint.xs ? '' : 'absolute',
                        }"
                        icon
                        @click.stop="
                          expandChosenTelevisionType =
                            !expandChosenTelevisionType
                        "
                      >
                        <v-icon
                          v-if="expandChosenTelevisionType"
                          medium
                        >
                          keyboard_arrow_up
                        </v-icon>
                        <v-icon
                          v-else
                          medium
                        >
                          keyboard_arrow_down
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex
                xs12
                sm5
              >
                <v-layout
                  column
                  class="full-height"
                  :class="{'pl-4 ml-auto': $vuetify.breakpoint.smAndUp}"
                >
                  <v-layout align-center>
                    <!-- Search -->
                    <v-text-field
                      v-model="searchTextModel"
                      :label="searchLabel"
                      hide-details
                      clearable
                      autofocus
                      append-icon="search"
                      style="z-index: 1000"
                      :loading="loading"
                      @click:clear="clearSearch()"
                      @keyup.native.esc="clearSearch()"
                    />
                    <!-- Screen Diagonal -->
                    <!-- <v-select
                      v-model="filterByScreenDiagonalModel"
                      :items="screenDiagonals"
                      class="ml-3"
                      :label="$t('televisionTypeScreenDiagonal')"
                      clearable
                      style="max-width: 84px; z-index: 1000"
                    /> -->
                    <!-- Stock yes/no -->
                    <v-checkbox
                      v-model="filterByStoreModel"
                      color="msr"
                      hide-details
                      class="ml-3"
                      :label="$t('televisionTypeAssignFilterByStoreCheckbox')"
                    />
                  </v-layout>
                  <v-slide-x-transition>
                    <v-layout
                      v-if="hasChanges"
                      nowrap
                      justify-center
                      class="ml-auto mt-3"
                    >
                      <v-btn
                        class="ml-0 mb-0"
                        round
                        :small="$vuetify.breakpoint.xs"
                        flat
                        @click="
                          chosenTelevisionType = tvdecoder.television_type
                        "
                      >
                        {{ $t('televisionTypeDiscardChanges') }}
                      </v-btn>
                      <v-btn
                        class="mr-0 mb-0"
                        round
                        :small="$vuetify.breakpoint.xs"
                        dark
                        color="msr"
                        @click="save()"
                      >
                        {{ $t('televisionTypeSaveChanges') }}
                      </v-btn>
                    </v-layout>
                  </v-slide-x-transition>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
          <pagination-controls
            v-if="televisionTypesPage"
            :show="showPaginationControls"
            :page.sync="televisionTypesPageIndexModel"
            :num-pages="televisionTypesPage.num_pages"
            hide-icons
          />
        </v-card-title>
        <v-card-text
          style="background: rgba(0, 0, 0, 0.06); height: 100%"
          :style="{
            opacity: loading ? 0.5 : 1,
          }"
        >
          <!-- Search Results (grouped TelevisionTypes) -->
          <div
            v-for="(productFamily, productFamilyIndex) in productFamilies"
            :key="'product-family-' + productFamilyIndex"
            :class="{
              'mt-3': productFamilyIndex > 0,
            }"
          >
            <div
              class="title font-weight-bold py-3"
              :class="{
                'warning--text': !productFamily,
              }"
            >
              {{ productFamily || $t('televisionTypeNoProductFamily') }}
              <div
                class="grey--text text--darken-1 caption mt-2"
                style="font-weight: normal"
              >
                {{ productFamilyToTelevisionTypes[productFamily].length }}
                <span
                  v-if="
                    productFamilyToTelevisionTypes[productFamily].length > 1
                  "
                >{{ $t('televisionTypes') }}</span>
                <span v-else>{{ $t('televisionType') }}</span>
              </div>
            </div>
            <v-card
              v-for="(
                televisionType, televisionTypeIndex
              ) in productFamilyToTelevisionTypes[productFamily]"
              :id="'television-type-' + televisionType.id"
              :key="'television-type-' + televisionType.id"
              ref="televisiontype-cards"
              style="position: relative"
            >
              <div
                v-if="
                  televisionTypeIdsWithStock.indexOf(televisionType.id) !== -1
                "
                style="
                  position: absolute;
                  left: 0;
                  top: 1px;
                  width: 6px;
                  height: 98%;
                  background: var(--msr-color-primary);
                "
                :title="$t('televisionTypeWithStockForStore')"
              />
              <div
                class="television-type clickable pl-3 pr-2 pt-2 pb-2"
                :class="{
                  'mt-4':
                    !televisionType.product_family && televisionTypeIndex > 0,
                  'television-type--selected':
                    !!chosenTelevisionType &&
                    televisionType.id === chosenTelevisionType.id,
                }"
                @click="chosenTelevisionType = televisionType"
              >
                <v-layout v-bind="televisionTypesLayout">
                  <!-- Text -->
                  <div>
                    {{ televisionType.label }}
                    <div
                      class="grey--text text--darken-2"
                      style="font-size: 10px"
                    >
                      {{ televisionType.article_number }}
                    </div>
                  </div>
                  <!-- Images -->
                  <div
                    :class="{
                      'ml-auto': $vuetify.breakpoint.smAndUp,
                      'mt-2': $vuetify.breakpoint.xs,
                    }"
                  >
                    <v-layout
                      align-center
                      justify-end
                    >
                      <div
                        class="ml-3 grey--text text--darken-3"
                        style="font-size: 20px"
                      >
                        {{ televisionType.screen_diagonal }}"
                      </div>
                      <img
                        v-if="televisionType.brand_logo_thumbnail_url"
                        :src="televisionType.brand_logo_thumbnail_url"
                        width="64"
                        class="ml-3"
                        style="
                          height: auto;
                          max-height: 36px;
                          object-fit: contain;
                        "
                      >
                      <img
                        v-if="televisionType.eek"
                        :src="eekToImageUrl[televisionType.eek]"
                        :title="televisionType.eek"
                        height="20"
                        class="ml-3"
                      >
                      <img
                        v-if="televisionType.product_thumbnail_image_url"
                        :src="televisionType.product_thumbnail_image_url"
                        :width="$vuetify.breakpoint.width < 400 ? 56 : 96"
                        class="ml-3"
                        style="
                          height: auto;
                          max-height: 56px;
                          object-fit: contain;
                        "
                      >
                      <div
                        v-else
                        class="ml-3"
                        style="min-width: 96px"
                      />
                    </v-layout>
                  </div>
                </v-layout>
              </div>
              <v-divider
                v-if="
                  televisionTypeIndex <
                    productFamilyToTelevisionTypes[productFamily].length - 1
                "
                :key="'television-type-divider-' + televisionType.id"
              />
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaginationControls from '@/components/PaginationControls';

import {EEK_TO_IMAGE_URL} from '@/pages/TelevisionTypeAssignment';

export default {
  components: {
    PaginationControls,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tvdecoder: {
      type: Object,
      default: null,
    },
    televisionTypesPage: {
      type: Object,
      default: null,
    },
    televisionTypesPageIndex: {
      type: Number,
      required: true,
    },
    televisionTypeIdsWithStock: {
      type: Array,
      default: () => [],
    },
    searchText: {
      type: String,
      default: '',
    },
    filterByScreenDiagonal: {
      type: Number,
      default: null,
    },
    filterByStore: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      expandChosenTelevisionType: this.$vuetify.breakpoint.smAndUp,
      chosenTelevisionType: null,
    };
  },
  computed: {
    showPaginationControls() {
      return this.televisionTypesPage && this.televisionTypesPage.num_pages > 1;
    },
    televisionTypesPageIndexModel: {
      get() {
        return this.televisionTypesPageIndex;
      },
      set(index) {
        this.$emit('update:televisionTypesPageIndex', index);
      },
    },
    televisionTypes() {
      return this.televisionTypesPage ? this.televisionTypesPage.results : [];
    },
    searchTextModel: {
      get() {
        return this.searchText;
      },
      set(searchText) {
        this.$emit('update:searchText', searchText);
      },
    },
    filterByScreenDiagonalModel: {
      get() {
        return this.filterByScreenDiagonal;
      },
      set(screenDiagonal) {
        this.$emit('update:filterByScreenDiagonal', screenDiagonal);
      },
    },
    filterByStoreModel: {
      get() {
        return this.filterByStore !== null;
      },
      set(enable) {
        if (enable) {
          this.$emit('update:filterByStore', this.tvdecoder.store.id);
        } else {
          this.$emit('update:filterByStore', null);
        }
      },
    },
    eekToImageUrl() {
      return EEK_TO_IMAGE_URL;
    },
    screenDiagonals() {
      const diagonals = [];
      for (const televisionType of this.televisionTypes) {
        if (
          televisionType.screen_diagonal &&
          !diagonals.includes(televisionType.screen_diagonal)
        ) {
          diagonals.push(televisionType.screen_diagonal);
        }
      }

      // Numerical sort: https://stackoverflow.com/a/1063027
      diagonals.sort((a, b) => a - b);

      return diagonals;
    },
    searchHint() {
      const overallCount = (this.televisionTypesPage || {}).overall_count;
      const matchedCount = (this.televisionTypesPage || {}).matched_count;
      if (matchedCount == overallCount) {
        return `${overallCount}`;
      }
      return `${matchedCount}/${overallCount}`;
    },
    searchLabel() {
      let suffix = '';
      if (!!this.searchHint) {
        suffix = ' (' + this.searchHint + ')';
      }
      return this.$t('search') + suffix;
    },
    televisionTypesLayout() {
      if (this.$vuetify.breakpoint.xs) {
        return {column: true, justifyContent: true};
      }
      return {row: true, alignCenter: true};
    },
    televisionTypesIncludingEntireProductFamily() {
      // Makes no sense to just show the individual matches, so show
      // the entire product_family of each also.
      return this.televisionTypes.filter((televisionType) => {
        return this.televisionTypes.some(
          (matchingTelevisionType) =>
            matchingTelevisionType.product_family ===
            televisionType.product_family
        );
      });
    },
    productFamilyToTelevisionTypes() {
      const grouped = {};
      for (const televisionType of this
        .televisionTypesIncludingEntireProductFamily) {
        if (!grouped[televisionType.product_family]) {
          grouped[televisionType.product_family] = [];
        }
        grouped[televisionType.product_family].push(televisionType);
      }
      return grouped;
    },
    productFamilies() {
      let productFamilyNames = Object.keys(this.productFamilyToTelevisionTypes);

      // Move 'ungrouped' TelevisionTypes (aka no product_family) to the bottom.
      if (productFamilyNames.includes('')) {
        productFamilyNames = productFamilyNames.filter(
          (productFamily) => productFamily != ''
        );
        productFamilyNames.push('');
      }

      return productFamilyNames;
    },
    hasChanges() {
      if (!this.tvdecoder) {
        return;
      }
      return this.tvdecoder.television_type !== this.chosenTelevisionType;
    },
  },
  watch: {
    show(show) {
      if (show) {
        this.chosenTelevisionType = this.tvdecoder.television_type;
        this.resetSearchAndFilters();
      } else {
        this.chosenTelevisionType = null;
      }
    },
  },
  methods: {
    scrollToChosenTelevisionTypeInList() {
      this.searchTextModel = this.chosenTelevisionType.article_number;

      this.$nextTick(() => {
        for (const ref of this.$refs['televisiontype-cards']) {
          if (
            ref.$el &&
            ref.$el.id == 'television-type-' + this.chosenTelevisionType.id
          ) {
            ref.$el.scrollIntoView({
              behavior: 'auto',
              block: 'center',
            });
            break;
          }
        }
      });
    },
    resetSearchAndFilters() {
      this.clearSearch();
      this.clearFilters();
    },
    clearSearch() {
      this.searchTextModel = '';
    },
    clearFilters() {
      this.filterByScreenDiagonalModel = null;
      this.filterByStoreModel = false;
    },
    close() {
      this.$emit('update:show', false);
    },
    save() {
      this.$emit('save', this.chosenTelevisionType);
      this.close();
    },
  },
};
</script>

<style scoped>
.television-type:hover {
  background-color: #f5f5f5;
}

.television-type--selected,
.television-type--selected:hover {
  background: rgba(255, 255, 0, 0.33) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TelevisionTypeAssignmentDialog.vue